import type { RouteConfig } from 'vue-router'

import * as namesConfiguracion from './nombres/configuracion'
import * as namesInformes from './nombres/informes'
import * as namesMantenimiento from './nombres/mantenimiento'
import * as namesTransacciones from './nombres/transacciones'
import { buildBreadcrumb } from '@/@core/utils/router'
import permisosContabilidadPg, { RESOURCE_CONTABILIDAD_PG } from '@/auth/permissions/modules/contabilidadPg'

const { mantenimiento, configuracion, transacciones, informes } = permisosContabilidadPg
export default [
    {
        path: '/contabilidad-pg/configuracion/plan-cuenta',
        name: namesConfiguracion.ROUTE_CREAR_PLAN_CUENTA,
        component: () => import('@/views/pages/contabilidad/configuracion/CrearPlanCuenta.vue'),
        meta: {
            title: 'i18n:contabilidad.configuracion.cuentas_contables.estado_plan_cuenta',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: configuracion.planCuenta,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.mantenimiento',
                'contabilidad.configuracion.cuentas_contables.estado_plan_cuenta'
            ),
        },
    },
    /**
     * RUTAS DE MANTENIMIENTOS
     */
    //ENTIDADES ORGANIZACIONALES
    {
        path: '/contabilidad-pg/mantenimiento/entidades-organizacionales',
        name: namesMantenimiento.ROUTE_ENTIDADES_ORGANIZACIONALES,
        component: () => import('@/views/pages/contabilidad/mantenimiento/EntidadesOrganizacionales.vue'),
        meta: {
            title: 'i18n:contabilidad.configuracion.entidades_organizacionales.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: mantenimiento.entidadesOrganizacionales,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.mantenimiento',
                'contabilidad.configuracion.entidades_organizacionales.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/mantenimiento/maestro-clase-cuenta',
        name: namesMantenimiento.ROUTE_MAESTRO_CLASE_CUENTA,
        component: () => import('@/views/pages/contabilidad/mantenimiento/ClaseCuentas.vue'),
        meta: {
            title: 'i18n:contabilidad.configuracion.clase_cuenta.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: mantenimiento.maestroClaseCuenta,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.mantenimiento',
                'contabilidad.configuracion.clase_cuenta.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/mantenimiento/estado-plan-cuenta',
        name: namesMantenimiento.ROUTE_ESTADO_PLAN_CUENTA,
        component: () => import('@/views/pages/contabilidad/mantenimiento/EstadoPlanCuenta.vue'),
        meta: {
            title: 'i18n:contabilidad.configuracion.cuentas_contables.estado_plan_cuenta',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: mantenimiento.estadoPlanCuenta,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.mantenimiento',
                'contabilidad.configuracion.cuentas_contables.estado_plan_cuenta'
            ),
        },
    },
    {
        path: '/contabilidad-pg/mantenimiento/plan-de-cuentas',
        name: namesMantenimiento.ROUTE_PLAN_DE_CUENTAS,
        component: () => import('@/views/pages/contabilidad-pg/mantenimiento/estado-plan-cuenta/GestionPlanCuenta.vue'),
        meta: {
            title: 'i18n:contabilidad.mantenimiento.plan_de_cuentas.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: mantenimiento.estadoPlanCuenta,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.mantenimiento',
                'contabilidad.configuracion.cuentas_contables.estado_plan_cuenta'
            ),
        },
    },
    {
        path: '/contabilidad-pg/mantenimiento/gestion-cc-sc',
        name: namesMantenimiento.ROUTE_GESTION_CC_SS,
        component: () => import('@/views/pages/contabilidad-pg/mantenimiento/GestionCentroSubCentroCosto.vue'),
        meta: {
            title: 'i18n:contabilidad.configuracion.gestion_cc_sc.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: mantenimiento.gestionCcSc,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.mantenimiento',
                'contabilidad.configuracion.gestion_cc_sc.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/mantenimiento/gestion-modulo-proceso-subproceso',
        name: namesMantenimiento.ROUTE_GESTION_MODULO_PROCESO_SUBPROCESO,
        component: () => import('@/views/pages/contabilidad/configuracion/GestionModuloProcesoSubproceso.vue'),
        meta: {
            title: 'i18n:contabilidad.configuracion.gestion_modulo_proceso_subproceso.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: mantenimiento.gestionModuloProcesoSubproceso,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.mantenimiento',
                'contabilidad.configuracion.gestion_modulo_proceso_subproceso.menu_title'
            ),
        },
    },

    /**
     * RUTAS DE CONFIGURACIÓN
     */
    {
        path: '/contabilidad-pg/configuracion/diario-apertura',
        name: namesConfiguracion.ROUTE_DIARIO_APERTURA,
        component: () => import('@/views/pages/contabilidad/configuracion/DiarioApertura.vue'),
        meta: {
            title: 'i18n:contabilidad.configuracion.diario_apertura.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: configuracion.diarioApertura,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.configuracion',
                'contabilidad.configuracion.diario_apertura.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/configuracion/permisos-administracion',
        name: namesConfiguracion.ROUTE_PERMISOS_ADMINISTRACION,
        component: () => import('@/views/pages/contabilidad/configuracion/Permisos.vue'),
        meta: {
            title: 'i18n:contabilidad.configuracion.permisos.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: configuracion.permisosAdministracion,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.configuracion',
                'contabilidad.configuracion.permisos.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/configuracion/permisos-transacciones',
        name: namesConfiguracion.ROUTE_PERMISOS_TRANSACCIONES,
        component: () => import('@/views/pages/contabilidad/configuracion/PermisosTransacciones.vue'),
        meta: {
            title: 'i18n:contabilidad.configuracion.permisos_transacciones.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: configuracion.permisosTransacciones,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.configuracion',
                'contabilidad.configuracion.permisos_transacciones.menu_title'
            ),
        },
    },

    {
        path: '/contabilidad-pg/configuracion/asignacion-permisos',
        name: namesConfiguracion.ROUTE_ASIGNACION_PERMISOS,
        component: () => import('@/views/pages/contabilidad/configuracion/AsignacionPermisos.vue'),
        meta: {
            title: 'i18n:contabilidad.configuracion.asignacion_permisos.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: configuracion.asignacionPermisos,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.configuracion',
                'contabilidad.configuracion.asignacion_permisos.menu_title'
            ),
        },
    },

    /**
     * RUTAS DE TRANSACCIONES
     */
    {
        path: '/contabilidad-pg/transacciones/cierre-contable',
        name: namesTransacciones.ROUTE_CIERRE_CONTABLE,
        component: () => import('@/views/pages/contabilidad/CierreContable.vue'),
        meta: {
            title: 'i18n:contabilidad.transacciones.cierre_contable.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: transacciones.cierreContable,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.transacciones',
                'contabilidad.transacciones.cierre_contable.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/transacciones/exportar-diarios',
        name: namesTransacciones.ROUTE_EXPORTAR_DIARIO,
        component: () => import('@/views/pages/contabilidad/informes/ExportacionMasivaDiarios.vue'),
        meta: {
            title: 'i18n:contabilidad.transacciones.exportar_diarios.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: transacciones.exportarDiario,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.transacciones',
                'contabilidad.transacciones.exportar_diarios.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/transacciones/importar-diarios',
        name: namesTransacciones.ROUTE_IMPORTAR_DIARIO,
        component: () => import('@/views/pages/contabilidad-pg/transacciones/importacionDiarios/ImportacionDiario.vue'),
        meta: {
            title: 'i18n:contabilidad.transacciones.importar_diarios.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: transacciones.importarDiario,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.transacciones',
                'contabilidad.transacciones.importar_diarios.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/transacciones/transacciones-contables',
        name: namesTransacciones.ROUTE_TRANSACCIONES_CONTABLES,
        component: () =>
            import('@/views/pages/contabilidad-pg/transacciones/transaccionContable/TransaccionContable.vue'),
        meta: {
            title: 'i18n:contabilidad.transacciones.transaccion_contable.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: transacciones.transaccionesContables,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.transacciones',
                'contabilidad.transacciones.transaccion_contable.menu_title'
            ),
        },
    },

    /**
     * RUTAS DE INFORMES
     */
    {
        path: '/contabilidad-pg/informes/anexos',
        name: namesInformes.ROUTE_ANEXOS,
        component: () => import('@/views/pages/contabilidad/informes/Anexo.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.anexos.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.anexos,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.anexos.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/anexos-activos-fijos',
        name: namesInformes.ROUTE_ANEXOS_ACTIVOS_FIJOS,
        component: () => import('@/views/pages/contabilidad/informes/AnexoActivosFijos.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.anexos_fijos.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.anexosActivosFijos,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.anexos_fijos.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/balance-comprobacion',
        name: namesInformes.ROUTE_BALANCE_COMPROBACION,
        component: () => import('@/views/pages/contabilidad/informes/BalanceComprobacion.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.balance_comprobacion.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.balanceComprobacion,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.balance_comprobacion.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/balance-comprobacion-segmentado-por-mes',
        name: namesInformes.ROUTE_BALANCE_COMPROBACION_SEGMENTADO,
        component: () => import('@/views/pages/contabilidad/informes/BalanceComprobacionSegmentado.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.balance_comprobacion_segmentado.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.balanceComprobacionSegmentado,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.balance_comprobacion_segmentado.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/balance-dinamico',
        name: namesInformes.ROUTE_BALANCE_DINAMICO,
        component: () => import('@/views/pages/contabilidad/informes/BalanceDinamico.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.balance_dinamico.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.balanceDinamico,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.balance_dinamico.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/balance-general',
        name: namesInformes.ROUTE_BALANCE_GENERAL,
        component: () => import('@/views/pages/contabilidad-pg/informes/BalanceGeneral.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.balance_general.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.balanceGeneral,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.balance_general.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/conciliacion-cuentas',
        name: namesInformes.ROUTE_CONCILIACION_CUENTAS,
        component: () => import('@/views/pages/contabilidad/informes/ConciliacionCuentas.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.conciliacion_cuentas.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.conciliacionCuentas,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.conciliacion_cuentas.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/costo-empacadoras',
        name: namesInformes.ROUTE_COSTO_EMPACADORAS,
        component: () => import('@/views/pages/contabilidad/informes/CostoEmpacadoras.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.costo_empacadoras.title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.costoEmpacadoras,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.costo_empacadoras.title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/costo-tilapiero',
        name: namesInformes.ROUTE_COSTO_TILAPIERO,
        component: () => import('@/views/pages/contabilidad/informes/CostosTilapieros.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.costo_tilapiero.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.costoTilapiero,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.costo_tilapiero.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/diario-general',
        name: namesInformes.ROUTE_DIARIO_GENERAL,
        component: () => import('@/views/pages/contabilidad/informes/DiarioGeneral.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.diario_general.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.diarioGeneral,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.diario_general.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/estado-financiero-segmentado',
        name: namesInformes.ROUTE_ESTADO_FINANCIERO_SEGMENTADO,
        component: () => import('@/views/pages/contabilidad/informes/EstadoFinancieroSegmentado.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.estado_financiero_segmentado.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.estadoFinancieroSegmentado,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.estado_financiero_segmentado.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/estado-pyg',
        name: namesInformes.ROUTE_ESTADO_PYG,
        component: () => import('@/views/pages/contabilidad/informes/EstadoPyG.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.estado_pyg.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.estadoPyg,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.estado_pyg.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/indicadores',
        name: namesInformes.ROUTE_INDICADORES,
        component: () => import('@/views/pages/contabilidad/informes/Indicadores.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.indicadores.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.indicadores,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.indicadores.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/mayor-general',
        name: namesInformes.ROUTE_MAYOR_GENERAL,
        component: () => import('@/views/pages/contabilidad/informes/MayorGeneral.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.mayor_general.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.mayorGeneral,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.mayor_general.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/mayor-patrimonio',
        name: namesInformes.ROUTE_MAYOR_PATRIMONIO,
        component: () => import('@/views/pages/contabilidad/informes/MayorPatrimonio.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.mayor_por_patrimonio.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.mayorPatrimonio,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.mayor_por_patrimonio.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/mayor-procesos',
        name: namesInformes.ROUTE_MAYOR_PROCESOS,
        component: () => import('@/views/pages/contabilidad/informes/MayorProcesos.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.mayor_por_procesos.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.mayorProcesos,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.mayor_por_procesos.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/movimientos-contables',
        name: namesInformes.ROUTE_MOVIMIENTOS_CONTABLES,
        component: () => import('@/views/pages/contabilidad/informes/ConsultaMovimientosContables.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.consulta_movimientos_contables.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.movimientosContables,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.consulta_movimientos_contables.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/movimientos-ventas-cxc',
        name: namesInformes.ROUTE_MOVIMIENTOS_VENTAS_CXC,
        component: () => import('@/views/pages/contabilidad/informes/Movimientosvyc.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.movimientosvyc.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.movimientosVentasCxC,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.movimientosvyc.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/plan-cuenta-cias',
        name: namesInformes.ROUTE_PLAN_CUENTA_CIAS,
        component: () => import('@/views/pages/contabilidad/informes/PlanCuentaCias.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.plan_cuenta_cias.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.planCuentaCias,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.plan_cuenta_cias.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/plan-cuenta-niif',
        name: namesInformes.ROUTE_PLAN_CUENTA_NIIF,
        component: () => import('@/views/pages/contabilidad/informes/PlanCuentaNIIF.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.plan_cuenta_niif.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.planCuentaNiif,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.plan_cuenta_niif.menu_title'
            ),
        },
    },
    {
        path: '/contabilidad-pg/informes/resumen-rentas',
        name: namesInformes.ROUTE_RESUMEN_RENTAS,
        component: () => import('@/views/pages/contabilidad/informes/ResumenRentas.vue'),
        meta: {
            title: 'i18n:contabilidad.informes.resumen_rentas.menu_title',
            resource: RESOURCE_CONTABILIDAD_PG,
            action: informes.resumenRentas,
            breadcrumb: buildBreadcrumb(
                'contabilidad.menu_title',
                'global.menu.informes',
                'contabilidad.informes.resumen_rentas.menu_title'
            ),
        },
    },
] as RouteConfig[]
